const all = ['frame-company'];

const findAll = (take?: number, skip?: number) => [...all, take, skip];

const findOne = (newsId: string | undefined) => [...all, newsId];

export const keys = { all, findAll, findOne };
